import React, { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthStore } from '@common/store/auth.store';

export const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = AuthStore((state) => state.isAuthenticated);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};
